import styled from "styled-components";

export const ContainerMain = styled.div`
    display: flex;
    //background-color: red;
    flex-direction: column;
    gap: 20px;
    margin: 20px 0px;
    
`